export default {
  header: 'Welcome to the websystem for workplace psychological assessments.',
  header_lisberg:
    'Welcome to the Lisberg web system for psychological testing!',
  content:
    '<p>If you are a trained and registered user: After logging in, you can administrate various test methods and download test results.</p><p>If you are invited to take a test using a code: Click on "Start test" (not on "Log in") and enter the code you received.</p>',
  content_lisberg:
    '<p>As a registered user you can let candidates take our tests and print the results. <br/>The same tests can also be sent by e-mail and answered from the candidate\'s home environment. <p>You can read more about the tests at <a href="http://www.lisberg.se" target="_blank">www.lisberg.se</a></p>',
  menu: 'Startpage'
}
